class QuickLinkValue {
  quickLinkValueId = 0;

  quickLinkId = 0;

  name = '';

  value = '';

  constructor(quickLinkValue) {
    this.quickLinkValueId = quickLinkValue.quickLinkValueId;
    this.quickLinkId = quickLinkValue.quickLinkId;
    this.name = quickLinkValue.name;
    this.value = quickLinkValue.value;
  }

  static fromObject(data) {
    if (data == null) {
      return null;
    }

    return new QuickLinkValue(data);
  }

  static fromObjects(list) {
    if (list == null) {
      return null;
    }

    return list.map((data) => QuickLinkValue.fromObject(data));
  }
}

export default QuickLinkValue;
